import { InvestmentAddressRequest } from '@core/api/models';
import {
  areAddressValuesWithCoordinatesEqual,
  formatShortAddress,
  toAddressFormValueWithCoordinates,
} from '@shared/utils/address-form.utils';

export interface InvestmentLocationData extends InvestmentAddressRequest {
  displayAddress?: string;
}

export function buildInvestmentLocationDisplayAddress(
  address: Partial<InvestmentAddressRequest> | null | undefined
): string {
  return formatShortAddress(address);
}

export function toInvestmentLocationData(
  address: Partial<InvestmentAddressRequest> | null | undefined
): InvestmentLocationData | null {
  if (!address) {
    return null;
  }

  const normalized = toAddressFormValueWithCoordinates(address);
  const location: InvestmentLocationData = {
    postalCode: normalized.postalCode,
    city: normalized.city,
    street: normalized.street,
    voivodeship: normalized.voivodeship,
    district: normalized.district,
    commune: normalized.commune,
    latitude: normalized.latitude ?? undefined,
    longitude: normalized.longitude ?? undefined,
  };

  return {
    ...location,
    displayAddress: buildInvestmentLocationDisplayAddress(location)
  };
}

export function toInvestmentAddressRequest(
  data: Partial<InvestmentAddressRequest> | null | undefined
): InvestmentAddressRequest {
  const normalized = toAddressFormValueWithCoordinates(data);

  return {
    postalCode: normalized.postalCode,
    city: normalized.city,
    street: normalized.street,
    voivodeship: normalized.voivodeship,
    district: normalized.district,
    commune: normalized.commune,
    latitude: normalized.latitude ?? undefined,
    longitude: normalized.longitude ?? undefined,
  };
}

export function areInvestmentLocationsEqual(
  left: Partial<InvestmentAddressRequest> | null | undefined,
  right: Partial<InvestmentAddressRequest> | null | undefined
): boolean {
  return areAddressValuesWithCoordinatesEqual(left, right);
}
